
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form} from "react-bootstrap";
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Bulldozer,ArrowsOutLineVertical,ArrowsOutLineHorizontal, Bridge   } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import atlasApi from "../utils/atlasapi";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import TurfArea from '@turf/area';
import TurfBuffer from '@turf/buffer';
import TurfDifference from '@turf/difference';
import TurfLength from '@turf/length';
import {formatArea, formatDistance, tempId, randomNumber, translateGeo, GeoJsonIcon} from "../utils/functions";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import drawTheme from "../utils/drawUtilsTheme";
import LayerDrawing		from "../classes/LayerDrawing";
import DrawingPanel		from "../components/DrawingPanel";
import Tool				from "../classes/Tool";
import circle				from '@turf/circle';


import {lineString, point, featureCollection} from '@turf/helpers';

class ToolDrawing extends Tool {

	tabIndex			= null;
	highlightedOnList	= [];
	allHidden			= false;

	itemsName			= 'drawings';
	id					= 'drawing_id';
	infolayerId			= 'drawings';
	currentColor		= LayerDrawing.defaultColor;
	currentThickness	= LayerDrawing.defaultThickness;
	currentOpacity		= LayerDrawing.defaultOpacity;
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	lastSelection		= null;
	
	type				= 'drawing'
	selected			= []
	
	constructor(p, type) {
		super();
		
		this.parent = p;
		this.draw	= p.draw.draw;
		this.tc		= p;
		this.type	= type;
		
		const {getters} = this.parent.draw.context;
		
		this.user = getters.user;
		
	}

	init(){
		
		Tool.prototype.init.call(this);
		this.setEventHandlers();
		this.tc.infoLayers.current.forceVisibility(this.infolayerId, true);	
		this.tc.map.getContainer().classList.add("cursor-drawing");
		if(this.user.settings?.tools?.draw?.defaultColor)
			this.currentColor = this.user.settings.tools.draw.defaultColor;

		this.display();

	}
	exit(){
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		
		this.parent.map.getContainer().classList.remove("cursor-drawing");
		
		
		this.closeDrawPanel();
	}
	
	stackDrawLayers = () =>{
		
		drawTheme.forEach((l)=>{
			if(this.tc.map.getLayer(l.id+".cold"))
				this.tc.map.moveLayer(l.id+".cold");
			if(this.tc.map.getLayer(l.id+".hot"))
				this.tc.map.moveLayer(l.id+".hot");
		});
		
	}
	getToolLayer(){
		return LayerDrawing;
	}
	getDrawings = () => {
		
		return atlasApi.getDrawings(this.tc.scenario.projectid, this.tc.scenario.scenario_id);
	}
	
	setEventHandlers(){

		if(!this.parent)
			return;

		this.tc.map.on('mousedown', this.handleMouseDown);
		this.tc.map.on('mouseup', this.handleMouseUp);


		this.tc.map.on('mouseenter', [LayerDrawing.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave', [LayerDrawing.layerId], this.handleMouseLeave);

		this.tc.map.on('mouseenter', [LayerDrawing.layerId], this.handleCursorChange);
		this.tc.map.on('mouseleave', [LayerDrawing.layerId], this.handleCursorChange);

		this.tc.map.on('contextmenu', this.handleRightClick);
		super.setEventHandlers();
	}
	removeEventHandlers(){
		if(!this.parent)
			return;

		this.tc.map.off('mousedown', this.handleMouseDown);
		this.tc.map.off('mouseup', this.handleMouseUp);

		this.tc.map.off('mouseenter', [LayerDrawing.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave', [LayerDrawing.layerId], this.handleMouseLeave);


		this.tc.map.off('mouseenter', [LayerDrawing.layerId], this.handleCursorChange);
		this.tc.map.off('mouseleave', [LayerDrawing.layerId], this.handleCursorChange);

		this.tc.map.off('contextmenu', this.handleRightClick);
		super.removeEventHandlers();
	}

	handleMouseUp = (e) =>  {
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerDrawing.layerId]});
		var clickedDrawing = features && features[0] ? features[0].properties.drawing_id : false;
		
		this.tc.map.off('mousemove', this.handleMouseMove);
		
		if(clickedDrawing){
			if(this.wasDragged){
				this.saveDrawing(this.currentLine);
				this.wasDragged = null;
			}
			return;
		}
		
		
		
		
		this.updateScenario(this.currentLine);
		
		this.currentLine	= false;
		this.currentDrawing = false;
		this.currentDrag	= false;
		this.currentPos		= false;
		
		this.tc.map.dragPan.enable();
	}
	handleMouseDown = (e) =>  {
		
		if (e.originalEvent.button !== 0) 
			return;
		
		this.tc.map.on('mousemove', this.handleMouseMove);
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerDrawing.layerId]});
		var clickedDrawing = features && features[0] ? features[0].properties.polygon_id : false;
		
		if(clickedDrawing){
			this.tc.map.dragPan.disable();
			this.startDragging(e, features[0]);
			this.handleEdit(features[0]);
			return;
		}
		
		this.currentWidth		= LayerDrawing.lineWidthInMeters(this.currentThickness, this.currentZoom, e.lngLat);
		
		
		this.tc.map.dragPan.disable();
	
		this.startDrawing(e);
	}
	startDragging = (e, feature) => {
		
		const data = this.getData();
		this.wasDragged = true;
		this.currentPos = [e.lngLat.lng, e.lngLat.lat];
		
	}
	startDrawing = (e) => {
		
		this.currentDrawing = {
			coordinates : [
				[e.lngLat.lng, e.lngLat.lat],
				[e.lngLat.lng+0.00000000001, e.lngLat.lat+0.00000000001]
			],
			tempid: randomNumber(),
			zoom: this.tc.map.getZoom(),
			center: this.tc.map.getCenter(),
			thickness: this.currentThickness,
			name: "Drawing " + (this.tc.scenario.drawings.length+1)
		};		
		this.initializeLine();
		
	}
	
	handleMouseMove = (e) => {

		if(this.currentDrawing){
			this.currentDrawing.coordinates.push([e.lngLat.lng, e.lngLat.lat]);
			if(!this._rafPending){
				this._rafPending = true;
				requestAnimationFrame(()=>{
					this.updateDrawing();
					this._rafPending = false;
				});
			}
		}
		else {
			this._lastDragEvent = e;
			if(!this._rafPending){
				this._rafPending = true;
				requestAnimationFrame(()=>{
					this.updateDrag(this._lastDragEvent);
					this._rafPending = false;
				});
			}
		}

	}
	handleCursorChange = (e)=>{
		this.tc.map.getContainer().classList[e && e.type == 'mouseenter' ? 'add' : 'remove']("cursor-pointer");
		
	}
	handleMouseEnter = (e)=>{
		if(!e.features.length)
			return;
		
		var drawingId = e.features[0].properties.drawing_id;
		
		if(drawingId>-1){
			this.highlightedOnList = [drawingId];
		}

		
		this.display();
	}
	
	
	handleMouseLeave = (e)=>{
		this.highlightedOnList = [];
		this.display();
	}
	handleRightClick = (e)=>{
		
		e.originalEvent.preventDefault();
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerDrawing.layerId]});
		
		if(!features.length)
			return;
		
		
		const f = features[0];
		
		var wrp = document.createElement("div");
		wrp.className = "toolContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';
		
		this.closeContextMenu();
		
		this.parent.map.getContainer().appendChild(wrp);
		
		this.addMapClickClose();
		ReactDOM.createRoot(wrp).render(this.contextMenuDelete(e, f.properties.drawing_id, f.geometry.type));
		
	}

	addMapClickClose(){
		
		document.addEventListener("click", this.closeContextMenu);
	}
	highlightOnMap = (row)=>{
		
		const id = row.drawing_id ?? row?.properties?.tempid;
		
		this.tc.map.setFeatureState({id:id, source:LayerDrawing.sourceId }, {hover:true});
		//for the circles
		this.tc.map.setFeatureState({id:10+id, source:LayerDrawing.sourceId}, {hover:true});
		
	}
	deHighlightOnMap = (row)=>{
		
		const id = row.drawing_id ?? row?.properties?.tempid;
		
		this.tc.map.setFeatureState({id:id, source:LayerDrawing.sourceId}, {hover:false});
		
		//for the circles
		this.tc.map.setFeatureState({id:10+id, source:LayerDrawing.sourceId}, {hover:false});
		
	}
	selectOnMap = ()=>{
		
		const id = this.drawingId;
		
		this.tc.map.setFeatureState({id:id, source:LayerDrawing.sourceId }, {selected:true});
		//for the circles
		this.tc.map.setFeatureState({id:10+id, source:LayerDrawing.sourceId}, {selected:true});
		
	}
	deSelectOnMap = ()=>{
		
		const id = this.drawingId;
		
		this.tc.map.setFeatureState({id:id, source:LayerDrawing.sourceId }, {selected:false});
		//for the circles
		this.tc.map.setFeatureState({id:10+id, source:LayerDrawing.sourceId}, {selected:false});
		
	}
	
	handleEdit = (row) => {
		
		//at this point all features have drawing_od
		const drawingId = row.drawing_id ?? row?.properties?.drawing_id ?? row?.properties?.polygon_id;
		
		if(drawingId === false)
			return;
		
		
		this.currentLine = this.tc.scenario.drawings.find((f)=>{
			return f.properties.drawing_id == drawingId;
		});
		
		this.currentColor = this.currentLine.properties.color;
		this.currentOpacity = this.currentLine.properties.opacity;
		this.currentThickness = this.currentLine.properties.thickness;
		this.currentZoom = this.currentLine.properties.zoom;
		
		
		this.openDrawPanel();
		
	}

	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
			this.exit();
			this.drawingModeForce();
		}
	}
	handleDeleteFromList(e, row){
		
		
		const drawingId = row.drawing_id ?? row?.properties?.drawing_id;
		
		if(drawingId === false)
			return;
		
		
		this.save(
			atlasApi.deleteDrawing(this.tc.scenario.projectid, this.tc.scenario.scenario_id, drawingId).then((res)=>{




				var s = {...this.tc.scenario};
				var data = this.getData();

				const index = s.drawings.findIndex(item => item.properties['drawing_id'] === drawingId);
				if (index !== -1) {
					s.drawings.splice(index, 1);
				}

				//remove line and polygon
				for (let i = data.features.length - 1; i >= 0; i--) {
					if (data.features[i].properties.drawing_id === drawingId)
						data.features.splice(i, 1);
				}
				this.tc.setScenario(s);
				this.setData(data);

				this.exit();
				this.drawingModeForce();

			})
		);
		
		
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(parseInt(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(parseInt(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}

	pName(row, index){
		return row.name ? row.name : 'Drawing '+ (index+1);
		
	}
	handleUpdateName = (val, row) => {
		
		const drawingId = row.drawing_id ?? row?.properties?.drawing_id;
		
		if(!drawingId)
			return;
		
		const payload = {name: val};
		
		this.updateScenarioFeatPop("drawing_id", drawingId, payload);
		this.updateMapFeatPop("drawing_id", drawingId, payload);

		this.save(atlasApi.updateDrawing(payload, this.tc.scenario.projectid, this.tc.scenario.scenario_id, drawingId));

	}
	handleChange = (obj) => {
		
		this.currentColor		= obj.color;
		this.currentThickness	= obj.thickness;
		this.currentOpacity		= obj.opacity;
		
		clearTimeout(this?.saveTimeout);
		
		this.saveTimeout = setTimeout(()=>{
			this.saveSetting('draw', {defaultColor:this.currentColor});
			this.saveDrawing(this.currentLine);
		}, 1000);
				
		if(!this.currentLine)
			return;
		
		const center = LayerDrawing.getCenter(this.currentLine);
		
		this.currentWidth = LayerDrawing.lineWidthInMeters(this.currentThickness, this.currentZoom, center);

		
		this.updateDrawing();
		this.updateExisting();
	}

	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(row.drawing_id);
	}
	
	contextMenuDelete(map_event, drawingId){
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEdit({drawing_id:drawingId}); this.closeContextMenu();}}><PencilSimple size={20} /> Edit object</button>
				<button className="btn" onClick={(e)=>{this.handleDeleteFromList(map_event, {drawing_id:drawingId}); this.closeContextMenu();}}><Trash size={20} /> Remove object</button>
			</>
		);
	}
	closeContextMenu = ()=>{
		
		
		document.removeEventListener("click", this.closeContextMenu);
		
		if(!this.parent)
			return;
		var a = false;
		if(a = this.parent.map.getContainer().querySelector(".toolContextMenu")){
			a.remove();
		}
		
		
	}

	closeDrawPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".drawingModePanel")){
			a.remove();
		}
		
		
	}
	openDrawPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "drawingModePanel";
		
		this.closeDrawPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		
		ReactDOM.createRoot(wrp).render(<DrawingPanel setup={{open:true, obj:{color:this.currentColor, thickness:this.currentThickness, opacity:this.currentOpacity}}} handler={this} onClose={this.handleOnClose} onSaveClose={this.handleSaveClose} onChange={this.handleChange} onDelete={()=>this.handleDeleteFromList(null, this.currentLine)} />	);
		
	}	

	updateDrawing = () => {
		if(this?.currentDrawing?.coordinates?.length > 1){
			

			

			const width = LayerDrawing.lineWidthInMeters(this.currentThickness, this.currentDrawing.zoom, {lng: this.currentDrawing.coordinates[0][0], lat: this.currentDrawing.coordinates[0][1] });
			var data = this.getData();
			//remove the original line
			
			var oldDrawing = data.features.find((p)=>{return this.currentDrawing.tempid == (p.properties?.tempid ?? this.properties?.tempid)});
			
			const newDrawing = TurfBuffer(this.currentLine, width, { units: 'meters' });

			
			if(oldDrawing)
				oldDrawing.geometry = newDrawing.geometry;
			else{
				newDrawing.properties.color = this.currentColor;
				newDrawing.properties.tempid = this.currentDrawing.tempid;
				newDrawing.properties.name = this.currentDrawing.name;
				data.features.push(newDrawing);
			}
			
			this.tc.map.getSource(LayerDrawing.sourceId).setData(data);
		}
	}
	updateExisting = () => {
		if(this?.currentLine && !this?.currentDrawing){
			
			var data = this.getData();
			//remove the original line
			
			this.currentLine.properties.color		= this.currentColor;
			this.currentLine.properties.thickness	= this.currentThickness;
			this.currentLine.properties.opacity		= this.currentOpacity;
		
		
			
			
			const newDrawing = TurfBuffer(this.currentLine, this.currentWidth, { units: 'meters' });
			
			
			this.updateMapFeatPop(
				"drawing_id", 
				this.currentLine.properties.drawing_id,
				{
					opacity: this.currentOpacity,
					color: this.currentColor,
					thickness: this.currentThickness,
				}
			);
			this.updateMapFeatGeo(
				"drawing_id", 
				this.currentLine.properties.drawing_id,
				newDrawing.geometry,
				(f)=>{return f.geometry.type == 'Polygon'}
			)
		}
	}
	updateDrag = (e) => {
		if(this.currentLine){

			const offset = this.getOffset(e);

			const data = this.getData();
			
			const oldDrawing = data.features.find((p)=>{
				return (p.properties.polygon_id == this.currentLine.properties.drawing_id);
			});

			if(oldDrawing){
				translateGeo(oldDrawing.geometry, offset);
				
				this.setData(data);
			}
			translateGeo(this.currentLine.geometry, offset);

			this.currentPos = [e.lngLat.lng, e.lngLat.lat];
		}
	}
	initializeLine = () => {
		
		if(!this?.currentDrawing?.coordinates?.length )
			return;

		this.currentLine = lineString(this.currentDrawing.coordinates);
		this.currentLine.properties = {
			tempid: this.currentDrawing.tempid,
			opacity: this.currentOpacity,
			color: this.currentColor,
			name: this.currentDrawing.name,
			center: this.currentDrawing.center,
			zoom: this.currentDrawing.zoom,
			thickness: this.currentDrawing.thickness
		};
		this.updateDrawing();
	}
	getOffset = (e) => {
		
		return [e.lngLat.lng-this.currentPos[0], e.lngLat.lat-this.currentPos[1]];
	}
	updateScenario = (line) => {
		
		var s = structuredClone(this.tc.scenario);
		
		var tempId = line.properties.tempid ?? 0;
		delete line.properties.tempid;
		
		this.saveDrawing(line).then((res)=>{
			
			
			var p = s.drawings.findIndex((d)=>{ return d.properties.drawing_id == res.properties.drawing_id});

			line.properties.drawing_id = res.properties.drawing_id;
			if(p>-1){
				s.drawings[p].properties = {
						...s.drawings[p].properties,
						...res.properties
				};
			}
			else{
				//add the line to scenario and map
				s.drawings.push(line);
				var data = this.getData();
				data.features.push(line);
				this.setData(data);
			}
			this.tc.setScenario(s);
			
			
			if(tempId){
				
				const mapline = structuredClone(res);
				
				mapline.properties.polygon_id = mapline.properties.drawing_id;
				mapline.properties.tempid = 0;
				this.handleEdit(mapline);
				this.updateMapFeatPop("tempid", tempId, mapline.properties);
			}
		});
		
		
		//s.modified = 1;

		//this.tc.record().add(s);
	}
	convertPolygon = (data) => {
		
		//because the api endpoint takes the properties at root level
		const res = {...data, ...data.properties};
		
		return res;
	}
	saveDrawing = (polygon) =>{
		
		if(polygon && polygon?.properties?.drawing_id){
			return this.save(atlasApi.updateDrawing(this.convertPolygon(polygon), this.tc.scenario.projectid, this.tc.scenario.scenario_id, polygon.properties.drawing_id));
		}
		else			
			return this.save(atlasApi.createDrawing(this.convertPolygon(polygon), this.tc.scenario.projectid, this.tc.scenario.scenario_id));
	}
	
	
	lineWidthInMeters = (lineWidthPx) => {
		const zoom = this.tc.map.getZoom();
		const center = {lng: this.currentDrawing.coordinates[0][0], lat: this.currentDrawing.coordinates[0][1] }; 
		const latitude = center.lat;

		const metersPerPixel =
			(156543.03392 * Math.cos(latitude * Math.PI / 180)) /
			Math.pow(2, zoom);

		return lineWidthPx * metersPerPixel;
	}
	
	drawingModeForce = () => {
		
		this.tc.handler = new ToolDrawing(this.tc, this.type);
		this.tc.handler.init();
		
	}
	handleOnClose = (e)=>{
		
		this.exit();
		this.drawingModeForce();
		
	}
	
	updateMapFeatGeo = (id, item_id, geo, cond) => {
		
		const data = this.getData();
		
		for (let i = data.features.length - 1; i >= 0; i--) {
			if (data.features[i].properties[id] == item_id && (!cond || cond(data.features[i]))){
				data.features[i].geometry = geo;
			}
		}
		
		this.setData(data);
	}
	handleSelect = (e, row) => {
		const idx = this.selected.findIndex((a) => a.drawing_id == row.drawing_id);
		if(idx !== -1)
			this.selected.splice(idx, 1);
		else
			this.selected.push(row);
		this.display();
	}
	handleSelectAll = () => {
		const lines = this.tc.scenario.drawings ?? [];
		const allSelected = lines.every(d => this.selected.some(s => s.drawing_id === d.properties.drawing_id));
		if (allSelected) {
			this.selected = [];
		} else {
			this.selected = lines.map(d => ({
				drawing_id: d.properties.drawing_id,
				name: d.properties.name
			}));
		}
		this.display();
	}
	removeItem = (id) => {
		const s = this.tc.scenario;
		s.drawings = (s.drawings || []).filter(d => (d.properties?.drawing_id ?? d.drawing_id) !== id);
		const data = this.getData();
		if (data) {
			for (let i = data.features.length - 1; i >= 0; i--) {
				if (data.features[i].properties.drawing_id === id)
					data.features.splice(i, 1);
			}
			this.setData(data);
		}
		this.tc.setScenario(s);
	}

	bulkDeleteApi = (ids) => atlasApi.bulkDeleteDrawings(this.tc.scenario.projectid, this.tc.scenario.scenario_id, ids);

	afterBulkDelete = (count) => {
		this.exit();
		this.drawingModeForce();
		const {QN} = this.tc.draw.context;
		QN.current.show("Deleted " + count + " drawing" + (count > 1 ? "s" : ""), <Button variant="primary btn-sm" onClick={() => { this.tc.undo(count); }}>Undo</Button>);
	}
	render(){
		const {getters} = this.parent.draw.context;
		
		

		var lines = (this.tc.scenario.drawings ?? []).map((c, idx)=>{
			
			const width = LayerDrawing.lineWidthInMeters(c.properties.thickness, c.properties.zoom, LayerDrawing.getCenter(c));
			
			const iconShape = TurfBuffer(c, width, { units: 'meters' });
			
			
			
			
			return {
				name: c.properties.name ?? 'Drawing ' + (idx+1),
				number: idx+1,
				drawing_id: c.properties.drawing_id ?? idx,
				type: c.geometry.type,
				geometry: c.geometry,
				icon: <GeoJsonIcon geojson={iconShape} size={20} color={c.properties.color} />
			}
		});
		return (
			
			<div className={"project-drawings "}>
				<div className="title">
					Drawing tool
					{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
					<div className="content p-0">

						<DataTable key={123}
							data={lines}
							columns={
								[
									
									{
										name:<Eye onClick={()=>{this.handleHideAllItems()}} className={""+(this.areAllHidden() ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row, index) =>	(<Eye onClick={(e)=>{this.handleToggleItem(e, row.drawing_id, undefined, false)}} id={"bndr_"+(row.drawing_id)} data-id={(row.drawing_id)}  className={""+(this.hiddenItems.includes(row.drawing_id) || this.allHidden ? 'opacity-25' : '')} size={16} />),
										maxWidth:"28px !important",
										style: {
											padding: '0',
										}
									},
									{
										name:(
											<Form.Check
												type="checkbox"
												checked={!!(this.tc.scenario.drawings?.length) && this.tc.scenario.drawings.every(d => this.selected.some(s => s.drawing_id === d.properties.drawing_id))}
												ref={el => { if (el) el.indeterminate = this.selected.length > 0 && this.selected.length < (this.tc.scenario.drawings?.length ?? 0); }}
												onChange={this.handleSelectAll}
											/>
										),
										selector: row => row.drawing_id,
										format: (row) => (
											<label className="checkbox-pad">
												<Form.Check
													type="checkbox"
													id={"check-"+row.drawing_id}
													checked={this.selected.some((a) => a.drawing_id == row.drawing_id)}
													onClick={(e) => { this.handleSelect(e, row); }}
												/>
											</label>
										),
										width:"25px",
										style: {
											padding: '0px !important',
											width:'25px'
										}
									},
									{
										name:'',
										id:'number',
										selector: (row,index) => {return index+1;},
										sortable: true,
										width:"24px",
										right: "true",
										format: (row, index) => (row.icon),
										minWidth:"21px !important",
										style: {
											justifyContent:"center"
										}

									},
									{
										name:'Drawing',
										selector: (row,index) => {return row.name},
										format: (row,index) => (<EditNow id={'drawing-'+(index)} value={this.pName(row,index)} key={'drawing-'+(index)} onClick={(e)=>{this.handleEdit(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, row)}} />),
										sortable:true,
										width:"100%",
										//maxWidth:"160px !important",
									},

									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
													<Dropdown className="minimal">
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<DotsThreeVertical size={16} />
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEdit(row);   }}><PencilSimple size={16} /> Change name</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEdit(row);   }}><PencilSimple size={16} /> Edit drawing</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleDeleteFromList(e, row); }} className="text-danger" ><Trash size={16} /> Remove drawing</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
											</div>
										),
										maxWidth:"20px !important"
										//minWidth:"160px !important",
										//maxWidth:"160px !important",
									}
								]
							}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={this.highlightOnMap}
							onRowMouseLeave={this.deHighlightOnMap}
							onRowClicked={this.handleEdit }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no drawings in this scenario.
									</Col>



								</Row>
							}
						/>

						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} drawing{this.selected.length > 1 ? "s" : ""} selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
					</div>


				</div>

			</div>
			
		);
		
	}
}



export { ToolDrawing};